import { useMediaQuery as useMantineMediaQuery } from '@mantine/hooks';

export const useMediaQuery = useMantineMediaQuery;
